import type { NodeOrganization } from 'models';
import { useCallback } from 'react';
import { EntitySnippet } from 'ui';
import { images } from 'common/utils';
import { useGetMediaSourceVariant } from 'features/media';
import type { OrganizationOption } from '../ChannelsSection';

export const useCreateOrganizationOption = () => {
  const getMediaSource = useGetMediaSourceVariant();

  return useCallback(
    (option: NodeOrganization): OrganizationOption => ({
      label: option.name,
      optionLabel: (
        <EntitySnippet
          avatarProps={{
            fallbackPhoto: images.default.organizationProfilePhoto,
            photo: getMediaSource({ id: option.id, type: 'organization_cover_photo' }),
            size: 'small',
          }}
          descriptionProps={{ children: option.settings?.allowCustomChannels ? 'Custom channels' : 'Default channels' }}
          titleProps={{ children: option.name }}
        />
      ),
      originalOrganization: option,
      value: option.id,
    }),
    [getMediaSource],
  );
};
